import { render, staticRenderFns } from "./staDean.vue?vue&type=template&id=19408902&scoped=true"
import script from "./staDean.vue?vue&type=script&lang=js"
export * from "./staDean.vue?vue&type=script&lang=js"
import style0 from "./staDean.vue?vue&type=style&index=0&id=19408902&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19408902",
  null
  
)

export default component.exports